import React, { type ReactNode } from 'react';
import { useDeviceType } from '../../../hooks/useDeviceType';
import { Container } from './Container';
import FadeInSection from '../../FadeInSection';
import { BlobLowerCorner, BlobUpperCorner } from '@icons/Blobs';
import NextImage from '../../NextImage';
import clsx from 'clsx';
import type { IRatingBanner } from '../index';

interface IContentWrapper
  extends Pick<IRatingBanner, 'ratingMsg' | 'settingRateData' | 'isPreparationStep'> {
  children: ReactNode;
}

export const ContentWrapper = ({
  children,
  ratingMsg,
  settingRateData,
  isPreparationStep,
}: IContentWrapper) => {
  const { isMobile } = useDeviceType();

  if (isPreparationStep) {
    return children;
  }

  const upperRight = ratingMsg?.upperRightCorner?.url;
  const lowerLeft = ratingMsg?.lowerLeftCorner?.url;
  const backgroundMobile = ratingMsg?.background?.[0]?.url;
  const backgroundDesktop = ratingMsg?.background?.[1]?.url;
  const styleBackground = isMobile && backgroundMobile ? backgroundMobile : backgroundDesktop;

  return (
    <Container ratingMsg={ratingMsg}>
      <div className="relative text-center rounded-b-2xl w-full lg:w-100/72 m-auto mt-20 sm:px-22 md:px-0">
        <div className="hidden md:block absolute right-[-22%] z-[-1] top-[-35%]">
          <FadeInSection delay="700ms" bounce>
            <BlobUpperCorner />
          </FadeInSection>
        </div>
        <div className="absolute hidden md:block right-[-17%] w-[290px] top-[-24%] z-[11] md:right-[-20%] md:top-[-20%] md:w-[220px] max-lg:right-[-20%] max-lg:top-[-20%] max-lg:w-[220px]">
          <FadeInSection delay="300ms">
            <NextImage src={upperRight} alt="" width={300} height={300} />
          </FadeInSection>
        </div>
        <div className="hidden md:block absolute left-[-15%] bottom-[-16%] z-[-1]">
          <FadeInSection delay="700ms" bounce fadeIn>
            <BlobLowerCorner />
          </FadeInSection>
        </div>
        <div className="hidden md:block absolute left-[-14%] bottom-[-22%] z-[11] w-[286px] md:left-[-17%] md:bottom-[-10$] md:w-[220px] max-lg:left-[-17%] max-lg:bottom-[-10$] max-lg:w-[220px]">
          <FadeInSection delay="300ms">
            <NextImage src={lowerLeft} alt="" width={300} height={300} />
          </FadeInSection>
        </div>
        <div
          className={clsx(
            'bg-no-repeat bg-cover print:hide relative text-center sm:w-full rounded-b-2xl w-full lg:w-100/72 m-auto mt-20 sm:px-22 md:px-0',
            isMobile ? 'rounded-t-2xl px-5 pb-0 h-[420px]' : 'bg-top z-10 w-full h-[405px]',
            !isMobile && settingRateData.isRatingGiven ? 'p-[33px]' : 'p-8.5',
            isMobile && settingRateData.isRatingGiven ? 'pt-[75px]' : 'pt-[82px]',
          )}
          style={{ background: styleBackground && `url(${styleBackground})` }}
        >
          {children}
        </div>
      </div>
    </Container>
  );
};
